import api from "./api";

export async function getLibraryDocuments(): Promise<any | null> {
    return await api
        .get("api/library-document/")
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function downloadLibraryDocument(
    libraryDocumentId: number
): Promise<any | null> {
    return await api
        .get("api/librarydocument/download/" + libraryDocumentId, {
            responseType: "blob",
        })
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}

export async function getLibraryDocument(
    libraryDocumentId: number
): Promise<any | null> {
    return await api
        .get("api/library-document/" + libraryDocumentId)
        .then((response) => {
            if (response.status >= 400) {
                throw new Error(JSON.stringify(response));
            }
            return response.data;
        })
        .catch((e: Error) => {
            const error = e.message ? e : JSON.parse(e.message);

            if (error.response) {
                return error.response.data;
            }
            return error;
        });
}
